define('drops/modalPopup/modalPopup',[
    'jquery',
    'lq/drop',
    'lq/modalblur',
    'drops/modals',
    'lq/style'
], function ($, Drop, ModalBlur, modals, Style) {
    'use strict';

    var minimumZIndexOfModalLayer = 6000;
    var minimumZIndexOfPopup = 6001;

    var defaults = {
        data: {
            size: { x: 200, y: 80 },
            lightBoxOpacity: 100,
            hasBlur: false,
            blur: 0,
            boxShadow: {
                enabled: false,
                color: 'rgb(136, 136, 136)',
                x: 0,
                y: 0,
                blur: 0,
                spread: 0
            },
            roundedCorners: {
                enabled: false,
                leftTopRadius: 0,
                rightTopRadius: 0,
                rightBottomRadius: 0,
                leftBottomRadius: 0
            },
            initialVisibility: false,
            initialVisibilityOption: "Hard Coded",
            renderInScrollContainer: false
        }
    };

    var ModalPopup = function (options) {
        Drop.call(this, $('<div />'), defaults, options);
        Style.renderStyles(this);
    };

    Drop.extend(ModalPopup, Drop);

    ModalPopup.typeName = 'ModalPopup';

    ModalPopup.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.applyZIndex();
        if (this.data.renderInScrollContainer && this.data.centeredVertically) {
            this.$verticalCentering = $('<div class = "vertical-centering"/>')
                .css({
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minHeight: '100%',
                    flexShrink: '0'
                });
            this.$element
                .css({
                    position: 'relative',
                    top: '0px'
                });
        }
    };

    ModalPopup.prototype.applyZIndex = function () {
        this.$element.css('zIndex', minimumZIndexOfPopup + this.data.zIndex);
    };

    ModalPopup.prototype.postRender = function () {
        Drop.prototype.postRender.apply(this, arguments);
        this.renderModalLayer(this.data);
    };

    ModalPopup.prototype.getHorizontalCenterPosition = function() {
        var totalWidth = $(window).width();
        return ((totalWidth - this.data.size.x) / 2) >= 0 ? (totalWidth - this.data.size.x) / 2 : 0;
    };

    ModalPopup.prototype.getVerticalCenterPosition = function () {
        var totalHeight = $(window).height();
        return ((totalHeight - this.data.size.y) / 2) >= 0 ? (totalHeight - this.data.size.y) / 2 : 0;
    };

    ModalPopup.prototype.autoPositionAt = function (targetPosition) {
        this.$element
            .css({
                left: targetPosition.left === null ? 'auto' : (targetPosition.left + 'px'),
                top: targetPosition.top === null ? 'auto' : (targetPosition.top + 'px'),
                right: targetPosition.right === null ? 'auto' : (targetPosition.right + 'px'),
                bottom: targetPosition.bottom === null ? 'auto' : (targetPosition.bottom + 'px')
            });

        if (!this.$scrollContainer) {
            this.$element.appendTo($('body'))
        }
    };

    ModalPopup.prototype.show = function () {
        var promise = Drop.prototype.show.call(this);

        if (this.$scrollContainer) {
            this.$scrollContainer.css({
                height: '100%',
                overflow: this.isScrollable() ? 'auto' : ''
            });
            this.updateScrollContainerZIndex();
            this.$scrollContainer.show();
            if (this.data.renderInScrollContainer && this.data.centeredVertically) {
                this.$scrollContainer
                    .css({
                        display: 'flex',
                        flexDirection: 'column'
                    });
            }
        }
        ModalBlur.applyBlur.call(this);

        this.addBackgroundClickHandler();

        return promise;
    };

    ModalPopup.prototype.afterHidden = function () {
        if (this.$modalLayer) {
            this.$modalLayer.hide();
        }
        if (this.$scrollContainer) {
            this.$scrollContainer.scrollTop(0);
            this.$scrollContainer.hide();
        }
        if (this.data.hasBlur) {
            ModalBlur.setBlurValue.call(this, 0);
        }
    };

    ModalPopup.prototype.hide = function () {
        this.removeBackgroundClickHandler();
        Drop.prototype.hide.call(this);
    };

    ModalPopup.prototype.addBackgroundClickHandler = function () {
        this.removeBackgroundClickHandler();
        var self = this, openTime = Date.now();
        this.backgroundClickHandler = function (event) {
            // We setup this flag when the animation starts in Drop.js.
            // Once the animation starts we need to wait till it's finished.
            if (self.animationInProgress)
                return;
            if (Date.now() - openTime < 50 || self.$element[0] === event.target || $.contains(self.$element[0], event.target))
                return;

            // e.g. the invisible input element that is used to upload files
            if (!$(event.target).is(':visible'))
                return;

            self.removeBackgroundClickHandler();

            if (self.data.closeWhenBackgroundClicked)
                self.hide();

            self.triggerEventIfEnabled('backgroundClicked');
        };
        this.piping.$app.on('click touchstart', this.backgroundClickHandler);
    };

    ModalPopup.prototype.removeBackgroundClickHandler = function () {
        if (this.backgroundClickHandler) {
            this.piping.$app.off('click touchstart', this.backgroundClickHandler);
            this.backgroundClickHandler = null;
        }
    };

    ModalPopup.prototype.renderModalLayer = function () {
        var bgColor = 'rgba(0, 0, 0, 0)';
        if (this.data.hasLightBox && this.data.lightBoxColor) {
            var splited = this.data.lightBoxColor.split(',');
            var opac =  parseFloat(splited[3]) * this.data.lightBoxOpacity / 100;
            bgColor = splited[0] + ',' + splited[1] + ',' + splited[2] + ', ' + opac + ')';
        }

        if (this.data.renderInScrollContainer || (this.data.autoPosition && this.data.autoPosition.enabled && this.data.hasLightBox)) {
            this.$scrollContainer = this.$scrollContainer || $('<div class = "scroll-container" />').hide();
            this.$scrollContainer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 0,
                    overflowY: 'hidden',
                    backgroundColor: bgColor
                });

            if (this.isVisible()) {
                this.updateScrollContainerZIndex();
            }

            if (this.data.toBrowser)
                this.$scrollContainer.appendTo(this.piping.$actionWrapper);
            else
                this.$scrollContainer.appendTo(this.piping.$modals);

            if (this.data.renderInScrollContainer && this.data.centeredVertically) {
                this.$verticalCentering.append(this.$element);
                this.$scrollContainer.append(this.$verticalCentering);
            }
            else {
                this.$scrollContainer.append(this.$element);
            }
        }
    };

    ModalPopup.prototype.updateScrollContainerZIndex = function () {
        if (this.piping.application.singlePage) {
            this.$scrollContainer.css('zIndex', modals.getNextZIndex());
        } else {
            this.$scrollContainer.css('zIndex', minimumZIndexOfModalLayer + this.data.zIndex);

            if (this.$scrollContainer) {
                this.$scrollContainer.css('zIndex', minimumZIndexOfModalLayer + this.data.zIndex - 1);
            }
        }
    };

    ModalPopup.prototype.render = function ($element) {
        var self = this;
        return this.createAndRenderDrops($element)
            .then(function () {
                if (!self.designData &&
                    !self.data.initialVisibility &&
                    self.data.autoPosition &&
                    self.data.autoPosition.enabled &&
                    self.autoPositionAt) {
                    self.autoPositionAt({
                        top: null,
                        left: null,
                        right: null,
                        bottom: null
                    });
                }
                if (self.isVisible()) {
                    self.show();
                }
            });
    };

    ModalPopup.prototype.isScrollable = function () {
        return this.data.renderInScrollContainer && this.$scrollContainer;
    };

    ModalPopup.prototype.unsubscribeEventHandlers = function () {
        this.removeBackgroundClickHandler();
        ModalBlur.setBlurValue.call(this, 0);

        if (this.$scrollContainer) {
            this.$scrollContainer.remove();
        }
    };

    ModalPopup.prototype.showWithoutAnimation = function () {
        if (this.data.autoPosition && this.data.autoPosition.enabled || this.designData) {
            Drop.prototype.showWithoutAnimation.call(this);
        } else {
            var self = this;
            return this.piping.viewTransitionManager.scheduleViewTransition(function () {
                // the drop may have been removed while this waited for its turn
                if (self.piping) Drop.prototype.showWithoutAnimation.call(self);
            });
        }
    };

    ModalPopup.prototype.hideWithoutAnimation = function () {
        if (this.data.autoPosition && this.data.autoPosition.enabled || this.designData) {
            Drop.prototype.hideWithoutAnimation.call(this);
        } else {
            var self = this;
            return this.piping.viewTransitionManager.scheduleViewTransition(function () {
                // the drop may have been removed while this waited for its turn
                if (self.piping) Drop.prototype.hideWithoutAnimation.call(self);
            });
        }
    };

    ModalPopup.prototype.updateVisibilityFromParameter = function (drop) {
        if (this.valueFromParameterIsTrue(drop))
            drop.showWithoutAnimation();
        else
            drop.hideWithoutAnimation();
    };

    return ModalPopup;
});

